import React from "react";
import axios from 'axios';
const API_URL='https://clubmiracle.asia/VM/web/';


export const _getLanguage=async(villa)=>{
    return axios.get(API_URL+'get-language.json', {
        //await axios.get('http://192.168.0.141/pwa-2/includes/api.php', {
        params: {
          villa:villa,
         }
        // await axios.get('http://192.168.0.141/pwa-2/includes/version.php', {  
      }).then(response => {
         return  response;
      }).catch(function (error) {
        console.log(error);
      })
}

export const _getContent=async(villa,language,page)=>{
    return axios.post(API_URL+'get-content.json', {
        //await axios.get('http://192.168.0.141/pwa-2/includes/api.php', {
           villa:villa,
          language:language,
          page:page
       // await axios.get('http://192.168.0.141/pwa-2/includes/version.php', {  
      }).then(response => {
         return  response;
       }).catch(function (error) {
        console.log(error);
      })

}

export const _sendMail=async(email,first_name,last_name,message,country,phone_number,send_email,villa_name)=>{
  return axios.post(API_URL+'send-mail.json', {
      //await axios.get('http://192.168.0.141/pwa-2/includes/api.php', {
        email:email,
        first_name:first_name,
        last_name:last_name,
        message:message,
        country:country,
        phone_number:phone_number,
        send_email:send_email,
        villa_name:villa_name
     // await axios.get('http://192.168.0.141/pwa-2/includes/version.php', {  
    }).then(response => {
       return  response;
     }).catch(function (error) {
      console.log(error);
    })

}